import { formatTimestampHuman } from "../date-utils";
export const productDtoFields = [{
        name: "name",
        title: "Nome",
        render: (record) => record.product.name
    }, {
        name: "updatedBy",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        title: "Ultima Modifica"
    }, {
        name: "updatedOn",
        title: "Data Modifica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.product.updatedOn)
    }];
